// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
  baseUrl: 'http://localhost:5001' | (string & {});
};

/**
 * A page of items returned from a paginated query, along with paging metadata.
 */
export type PaginatedListDtoOfMinifiedSurveyVersionDto = {
  /**
   * Gets the total number of pages, computed from TotalCount and PageSize.
   */
  totalPages: number;
  /**
   * Gets a value indicating whether there is a page after this one.
   */
  hasNextPage: boolean;
  /**
   * Gets a value indicating whether there is a page before this one.
   */
  hasPreviousPage: boolean;
  /**
   * Gets the items included in this page.
   */
  items: Array<MinifiedSurveyVersionDto>;
  /**
   * Gets the total number of items across all pages.
   */
  totalCount: number;
  /**
   * Gets the zero-based index of this page.
   */
  page: number;
  /**
   * Gets the maximum number of items per page.
   */
  pageSize: number;
};

/**
 * A condensed representation of a survey version, exposing only summary fields.
 */
export type MinifiedSurveyVersionDto = {
  /**
   * Gets the slug of the survey this version belongs to.
   */
  surveySlug: string;
  /**
   * Gets a value indicating whether this survey version is published.
   */
  isPublished: boolean;
  /**
   * Gets the version number of the survey version.
   */
  versionNumber: number;
  /**
   * Gets the date and time the survey version was created.
   */
  createdAt: string;
  /**
   * Gets the date and time the survey version was last updated.
   */
  updatedAt: string;
};

/**
 * Request to retrieve all versions of a survey with pagination.
 */
export type GetAllSurveyVersionsRequest = {
  [key: string]: never;
};

/**
 * the dto used to send an error response to the client
 */
export type ErrorResponse = {
  /**
   * the http status code sent to the client. default is 400.
   */
  statusCode: number;
  /**
   * the message for the error response
   */
  message: string;
  /**
   * the collection of errors for the current context
   */
  errors: {
    [key: string]: Array<string>;
  };
};

/**
 * Represents a specific version of a survey, including its section and question structure.
 */
export type SurveyVersionDto = {
  /**
   * Gets or sets the slug of the survey this version belongs to.
   */
  surveySlug: string;
  /**
   * Gets or sets the version number of the survey version.
   */
  versionNumber: number;
  /**
   * Gets or sets a value indicating whether this survey version is published.
   */
  isPublished: boolean;
  /**
   * Gets or sets the date and time the survey version was created.
   */
  createdAt: string;
  /**
   * Gets or sets the date and time the survey version was last updated.
   */
  updatedAt: string;
  /**
   * Gets or sets the sections that make up this survey version.
   */
  sections: Array<SurveySection>;
};

/**
 * A named group of questions within a survey version.
 */
export type SurveySection = {
  /**
   * Gets or sets the unique identifier used to reference this section.
   */
  sectionSlug: string;
  /**
   * Gets or sets the display title of this section.
   */
  title: string;
  /**
   * Gets or sets the questions contained in this section.
   */
  questions: Array<Question>;
};

export type Question = (
  TextQuestion | TabularQuestion | SelectionQuestion | PhoneQuestion | NumericQuestion | EmailQuestion | BooleanQuestion
) & {
  /**
   * Gets or sets the unique identifier used to reference this question.
   */
  slug?: string;
  /**
   * Gets or sets the optional helper text displayed alongside the question.
   */
  tooltip?: string | null;
  /**
   * Gets or sets the markdown content displayed for the question, such as its prompt text.
   */
  markdownContent?: string;
  /**
   * Gets or sets a value indicating whether an answer must be provided for this question.
   */
  isRequired?: boolean;
  /**
   * Gets or sets the condition that determines whether this question is visible within a submission.
   */
  condition?: QuestionCondition | null;
  /**
   * Gets or sets the tags used to categorize or identify this question.
   */
  tags?: Array<QuestionTags>;
  /**
   * Gets or sets a value indicating whether this question's response may be copied into a submission template.
   */
  includeInTemplate?: boolean | null;
  type: string;
};

export type QuestionCondition = (EqualityQuestionCondition | LogicalAndQuestionCondition) & {
  /**
   * Gets or sets the operator used to evaluate the condition.
   */
  operator?: QuestionConditionalOperator;
  $type: string;
};

/**
 * Comparison operators used to evaluate a question condition against a reference value.
 */
export const QuestionConditionalOperator = {
  /**
   * NotNull
   */
  NotNull: 'NotNull',
  /**
   * Null
   */
  Null: 'Null',
  /**
   * Equal
   */
  Equal: 'Equal',
  /**
   * NotEqual
   */
  NotEqual: 'NotEqual',
  /**
   * GreaterThan
   */
  GreaterThan: 'GreaterThan',
  /**
   * GreaterThanOrEqual
   */
  GreaterThanOrEqual: 'GreaterThanOrEqual',
  /**
   * LessThan
   */
  LessThan: 'LessThan',
  /**
   * LessThanOrEqual
   */
  LessThanOrEqual: 'LessThanOrEqual',
  /**
   * Some
   */
  Some: 'Some',
  /**
   * All
   */
  All: 'All',
  /**
   * None
   */
  None: 'None',
} as const;

/**
 * Comparison operators used to evaluate a question condition against a reference value.
 */
export type QuestionConditionalOperator =
  (typeof QuestionConditionalOperator)[keyof typeof QuestionConditionalOperator];

export type EqualityQuestionCondition = {
  /**
   * Gets or sets the operator used to evaluate the condition.
   */
  operator: QuestionConditionalOperator;
  $type: 'equality';
  /**
   * Gets the left-hand value of the comparison.
   */
  left: QuestionConditionValue;
  /**
   * Gets the right-hand value of the comparison.
   */
  right: QuestionConditionValue;
};

export type BinaryQuestionCondition = QuestionCondition & {
  /**
   * Gets the left-hand value of the comparison.
   */
  left: QuestionConditionValue;
  /**
   * Gets the right-hand value of the comparison.
   */
  right: QuestionConditionValue;
  $type: string;
};

export type QuestionConditionValue = (QuestionConditionReferenceValue | QuestionConditionStaticValue) & {
  $type: string;
};

export type QuestionConditionReferenceValue = {
  $type: 'reference';
  /**
   * Gets the slug of the question whose response value this refers to.
   */
  referenceSlug: string;
};

export type QuestionConditionStaticValue = {
  $type: 'static';
  /**
   * Gets the fixed string value.
   */
  value?: string | null;
};

export type LogicalAndQuestionCondition = {
  /**
   * Gets or sets the operator used to evaluate the condition.
   */
  operator: QuestionConditionalOperator;
  $type: 'and';
  /**
   * Gets the left-hand condition to combine.
   */
  left: QuestionCondition;
  /**
   * Gets the right-hand condition to combine.
   */
  right: QuestionCondition;
};

export type CompoundQuestionCondition = QuestionCondition & {
  /**
   * Gets the left-hand condition to combine.
   */
  left: QuestionCondition;
  /**
   * Gets the right-hand condition to combine.
   */
  right: QuestionCondition;
  $type: string;
};

/**
 * Semantic tags applied to questions so their responses can be located and interpreted by downstream logic.
 */
export const QuestionTags = {
  /**
   * Name
   */
  Name: 'Name',
  /**
   * Email
   */
  Email: 'Email',
  /**
   * PayPeriodsPerYear
   */
  PayPeriodsPerYear: 'PayPeriodsPerYear',
  /**
   * IncomeAmount
   */
  IncomeAmount: 'IncomeAmount',
  /**
   * TaxTiming
   */
  TaxTiming: 'TaxTiming',
  /**
   * SecondaryIncome
   */
  SecondaryIncome: 'SecondaryIncome',
  /**
   * User
   */
  User: 'User',
  /**
   * Spouse
   */
  Spouse: 'Spouse',
  /**
   * IncomeCategory
   */
  IncomeCategory: 'IncomeCategory',
  /**
   * EpisodicExpense
   */
  EpisodicExpense: 'EpisodicExpense',
  /**
   * FixedExpense
   */
  FixedExpense: 'FixedExpense',
  /**
   * VariableExpense
   */
  VariableExpense: 'VariableExpense',
  /**
   * ExpenseCategory
   */
  ExpenseCategory: 'ExpenseCategory',
  /**
   * ExpenseDescription
   */
  ExpenseDescription: 'ExpenseDescription',
  /**
   * ExpenseAmount
   */
  ExpenseAmount: 'ExpenseAmount',
} as const;

/**
 * Semantic tags applied to questions so their responses can be located and interpreted by downstream logic.
 */
export type QuestionTags = (typeof QuestionTags)[keyof typeof QuestionTags];

export type BooleanQuestion = {
  /**
   * Gets or sets the unique identifier used to reference this question.
   */
  slug: string;
  /**
   * Gets or sets the optional helper text displayed alongside the question.
   */
  tooltip?: string | null;
  /**
   * Gets or sets the markdown content displayed for the question, such as its prompt text.
   */
  markdownContent: string;
  /**
   * Gets or sets a value indicating whether an answer must be provided for this question.
   */
  isRequired: boolean;
  /**
   * Gets or sets the condition that determines whether this question is visible within a submission.
   */
  condition?: QuestionCondition | null;
  /**
   * Gets or sets the tags used to categorize or identify this question.
   */
  tags: Array<QuestionTags>;
  /**
   * Gets or sets a value indicating whether this question's response may be copied into a submission template.
   */
  includeInTemplate?: boolean | null;
  type: 'boolean';
  /**
   * Gets or sets the default answer for the question.
   */
  defaultValue?: boolean | null;
  /**
   * Gets or sets a value indicating whether the question should be presented as a dropdown instead of a toggle/checkbox.
   */
  dropdown: boolean;
};

export type QuestionOfBooleanResponseAndBooleanQuestionAndBoolean = Question & {
  type: string;
};

export type EmailQuestion = {
  /**
   * Gets or sets the unique identifier used to reference this question.
   */
  slug: string;
  /**
   * Gets or sets the optional helper text displayed alongside the question.
   */
  tooltip?: string | null;
  /**
   * Gets or sets the markdown content displayed for the question, such as its prompt text.
   */
  markdownContent: string;
  /**
   * Gets or sets a value indicating whether an answer must be provided for this question.
   */
  isRequired: boolean;
  /**
   * Gets or sets the condition that determines whether this question is visible within a submission.
   */
  condition?: QuestionCondition | null;
  /**
   * Gets or sets the tags used to categorize or identify this question.
   */
  tags: Array<QuestionTags>;
  /**
   * Gets or sets a value indicating whether this question's response may be copied into a submission template.
   */
  includeInTemplate?: boolean | null;
  type: 'email';
  /**
   * Gets or sets the default answer for the question.
   */
  defaultValue?: string | null;
};

export type QuestionOfEmailResponseAndEmailQuestionAndString = Question & {
  type: string;
};

export type NumericQuestion = {
  /**
   * Gets or sets the unique identifier used to reference this question.
   */
  slug: string;
  /**
   * Gets or sets the optional helper text displayed alongside the question.
   */
  tooltip?: string | null;
  /**
   * Gets or sets the markdown content displayed for the question, such as its prompt text.
   */
  markdownContent: string;
  /**
   * Gets or sets a value indicating whether an answer must be provided for this question.
   */
  isRequired: boolean;
  /**
   * Gets or sets the condition that determines whether this question is visible within a submission.
   */
  condition?: QuestionCondition | null;
  /**
   * Gets or sets the tags used to categorize or identify this question.
   */
  tags: Array<QuestionTags>;
  /**
   * Gets or sets a value indicating whether this question's response may be copied into a submission template.
   */
  includeInTemplate?: boolean | null;
  type: 'numeric';
  /**
   * Gets or sets the default answer for the question.
   */
  defaultValue?: number | null;
  /**
   * Gets or sets the minimum value permitted for the answer.
   */
  min?: number | null;
  /**
   * Gets or sets the maximum value permitted for the answer.
   */
  max?: number | null;
  /**
   * Gets or sets the symbol displayed alongside the answer, such as a currency or unit symbol.
   */
  symbol?: string | null;
  /**
   * Gets or sets text displayed after the answer field, such as a unit label.
   */
  postText?: string | null;
};

export type QuestionOfNumericResponseAndNumericQuestionAndDecimal = Question & {
  type: string;
};

export type PhoneQuestion = {
  /**
   * Gets or sets the unique identifier used to reference this question.
   */
  slug: string;
  /**
   * Gets or sets the optional helper text displayed alongside the question.
   */
  tooltip?: string | null;
  /**
   * Gets or sets the markdown content displayed for the question, such as its prompt text.
   */
  markdownContent: string;
  /**
   * Gets or sets a value indicating whether an answer must be provided for this question.
   */
  isRequired: boolean;
  /**
   * Gets or sets the condition that determines whether this question is visible within a submission.
   */
  condition?: QuestionCondition | null;
  /**
   * Gets or sets the tags used to categorize or identify this question.
   */
  tags: Array<QuestionTags>;
  /**
   * Gets or sets a value indicating whether this question's response may be copied into a submission template.
   */
  includeInTemplate?: boolean | null;
  type: 'phone';
  /**
   * Gets or sets the default answer for the question.
   */
  defaultValue?: string | null;
};

export type QuestionOfPhoneResponseAndPhoneQuestionAndString = Question & {
  type: string;
};

export type SelectionQuestion = {
  /**
   * Gets or sets the unique identifier used to reference this question.
   */
  slug: string;
  /**
   * Gets or sets the optional helper text displayed alongside the question.
   */
  tooltip?: string | null;
  /**
   * Gets or sets the markdown content displayed for the question, such as its prompt text.
   */
  markdownContent: string;
  /**
   * Gets or sets a value indicating whether an answer must be provided for this question.
   */
  isRequired: boolean;
  /**
   * Gets or sets the condition that determines whether this question is visible within a submission.
   */
  condition?: QuestionCondition | null;
  /**
   * Gets or sets the tags used to categorize or identify this question.
   */
  tags: Array<QuestionTags>;
  /**
   * Gets or sets a value indicating whether this question's response may be copied into a submission template.
   */
  includeInTemplate?: boolean | null;
  type: 'selection';
  /**
   * Gets or sets a value indicating whether the question allows a free-text "other" option in addition to Options.
   */
  hasOther: boolean;
  /**
   * Gets or sets a value indicating whether more than one option may be selected.
   */
  multiselect: boolean;
  /**
   * Gets or sets a value indicating whether the question offers an "all of the above" option.
   */
  hasAllOfTheAbove: boolean;
  /**
   * Gets or sets a value indicating whether the question offers a "none of the above" option.
   */
  hasNoneOfTheAbove: boolean;
  /**
   * Gets or sets a value indicating whether the question should be presented as a dropdown instead of a list of choices.
   */
  dropdown: boolean;
  /**
   * Gets or sets the list of selectable options for the question.
   */
  options: Array<string>;
  /**
   * Gets or sets the default answer for the question.
   */
  defaultValue: Array<string>;
};

export type QuestionOfSelectionResponseAndSelectionQuestionAndIEnumerableOfString = Question & {
  type: string;
};

export type TabularQuestion = {
  /**
   * Gets or sets the unique identifier used to reference this question.
   */
  slug: string;
  /**
   * Gets or sets the optional helper text displayed alongside the question.
   */
  tooltip?: string | null;
  /**
   * Gets or sets the markdown content displayed for the question, such as its prompt text.
   */
  markdownContent: string;
  /**
   * Gets or sets a value indicating whether an answer must be provided for this question.
   */
  isRequired: boolean;
  /**
   * Gets or sets the condition that determines whether this question is visible within a submission.
   */
  condition?: QuestionCondition | null;
  /**
   * Gets or sets the tags used to categorize or identify this question.
   */
  tags: Array<QuestionTags>;
  /**
   * Gets or sets a value indicating whether this question's response may be copied into a submission template.
   */
  includeInTemplate?: boolean | null;
  type: 'tabular';
  /**
   * Gets or sets a value indicating whether the respondent may add new rows to the table.
   */
  allowAddRows: boolean;
  /**
   * Gets or sets a value indicating whether the respondent may delete rows that were present by default.
   */
  allowDeleteDefaultRows: boolean;
  /**
   * Gets or sets the questions that make up the columns of the table.
   */
  columns: Array<TabularQuestionColumn>;
};

/**
 * Configuration class for a column inside of a tabular question.
 */
export type TabularQuestionColumn = {
  /**
   * Gets the question captured within the table column.
   */
  question: Question;
  /**
   * Gets or sets a value indicating whether the default entries for this column are readonly.
   */
  isDefaultReadOnly: boolean;
  /**
   * Gets or sets the default values for this column.
   */
  defaultValues: Array<string>;
  /**
   * Gets or sets the aggregation function applied to this column, if any.
   */
  aggregationFunction?: AggregationFunction | null;
};

/**
 * Enum containing the set of available question aggregation functions.
 */
export const AggregationFunction = {
  /**
   * Sum
   */
  Sum: 'Sum',
} as const;

/**
 * Enum containing the set of available question aggregation functions.
 */
export type AggregationFunction = (typeof AggregationFunction)[keyof typeof AggregationFunction];

export type QuestionOfTabularResponseAndTabularQuestionAndDictionaryOfStringAndStringOf = Question & {
  type: string;
};

export type TextQuestion = {
  /**
   * Gets or sets the unique identifier used to reference this question.
   */
  slug: string;
  /**
   * Gets or sets the optional helper text displayed alongside the question.
   */
  tooltip?: string | null;
  /**
   * Gets or sets the markdown content displayed for the question, such as its prompt text.
   */
  markdownContent: string;
  /**
   * Gets or sets a value indicating whether an answer must be provided for this question.
   */
  isRequired: boolean;
  /**
   * Gets or sets the condition that determines whether this question is visible within a submission.
   */
  condition?: QuestionCondition | null;
  /**
   * Gets or sets the tags used to categorize or identify this question.
   */
  tags: Array<QuestionTags>;
  /**
   * Gets or sets a value indicating whether this question's response may be copied into a submission template.
   */
  includeInTemplate?: boolean | null;
  type: 'text';
  /**
   * Gets or sets the default answer for the question.
   */
  defaultValue?: string | null;
  /**
   * Gets or sets the type of text field used to render the question, such as "text" or "textarea".
   */
  textfieldType: string;
};

export type QuestionOfTextResponseAndTextQuestionAndString = Question & {
  type: string;
};

/**
 * Request to retrieve the current published version of a survey.
 */
export type GetCurrentSurveyVersionRequest = {
  [key: string]: never;
};

/**
 * Request to retrieve a specific numbered version of a survey.
 */
export type GetSpecificSurveyVersionRequest = {
  [key: string]: never;
};

/**
 * A page of items returned from a paginated query, along with paging metadata.
 */
export type PaginatedListDtoOfSurveyDto = {
  /**
   * Gets the total number of pages, computed from TotalCount and PageSize.
   */
  totalPages: number;
  /**
   * Gets a value indicating whether there is a page after this one.
   */
  hasNextPage: boolean;
  /**
   * Gets a value indicating whether there is a page before this one.
   */
  hasPreviousPage: boolean;
  /**
   * Gets the items included in this page.
   */
  items: Array<SurveyDto>;
  /**
   * Gets the total number of items across all pages.
   */
  totalCount: number;
  /**
   * Gets the zero-based index of this page.
   */
  page: number;
  /**
   * Gets the maximum number of items per page.
   */
  pageSize: number;
};

/**
 * Represents a survey.
 */
export type SurveyDto = {
  /**
   * Gets the name of the survey.
   */
  name: string;
  /**
   * Gets the slug of the survey.
   */
  slug: string;
  /**
   * Gets the date and time the survey was created.
   */
  createdAt: string;
  /**
   * Gets the date and time the survey was last updated.
   */
  updatedAt: string;
};

/**
 * Request to retrieve all surveys with optional filtering and pagination.
 */
export type GetAllSurveysRequest = {
  [key: string]: never;
};

/**
 * Request to retrieve a survey by slug.
 */
export type GetSurveyRequest = {
  [key: string]: never;
};

/**
 * Request to update the responses on an existing submission template.
 */
export type UpdateSubmissionTemplateRequest = {
  /**
   * Gets or sets the updated responses, keyed by question slug.
   */
  responses: {
    [key: string]: string | null;
  };
  /**
   * Gets or sets the updated display name of the template. If omitted, the existing name is left unchanged.
   */
  name?: string | null;
};

/**
 * Represents a reusable collection of responses that can be used to pre-populate a new submission.
 */
export type SubmissionTemplateDto = {
  /**
   * Gets or sets the unique identifier of the template.
   */
  id: string;
  /**
   * Gets or sets the slug of the survey the template belongs to.
   */
  surveySlug: string;
  /**
   * Gets or sets the display name of the template.
   */
  name: string;
  /**
   * Gets or sets the date and time the template was created.
   */
  createdAt: string;
  /**
   * Gets or sets the date and time the template was last updated.
   */
  updatedAt: string;
  /**
   * Gets or sets the template's responses, keyed by question slug.
   */
  responses: {
    [key: string]: string;
  };
};

/**
 * Request to retrieve a specific submission template belonging to a survey.
 */
export type GetSubmissionTemplateRequest = {
  [key: string]: never;
};

/**
 * A page of items returned from a paginated query, along with paging metadata.
 */
export type PaginatedListDtoOfSubmissionTemplateDto = {
  /**
   * Gets the total number of pages, computed from TotalCount and PageSize.
   */
  totalPages: number;
  /**
   * Gets a value indicating whether there is a page after this one.
   */
  hasNextPage: boolean;
  /**
   * Gets a value indicating whether there is a page before this one.
   */
  hasPreviousPage: boolean;
  /**
   * Gets the items included in this page.
   */
  items: Array<SubmissionTemplateDto>;
  /**
   * Gets the total number of items across all pages.
   */
  totalCount: number;
  /**
   * Gets the zero-based index of this page.
   */
  page: number;
  /**
   * Gets the maximum number of items per page.
   */
  pageSize: number;
};

/**
 * Request to retrieve all submission templates belonging to a survey, with pagination.
 */
export type GetSubmissionTemplatesRequest = {
  [key: string]: never;
};

/**
 * Request to soft-delete an existing submission template.
 */
export type DeleteSubmissionTemplateRequest = {
  [key: string]: never;
};

/**
 * Request to create a reusable submission template from an existing submission.
 */
export type CreateSubmissionTemplateRequest = {
  /**
   * Gets or sets the ID of the submission to create the template from.
   */
  submissionId: string;
  /**
   * Gets or sets the display name of the template. If omitted, a default name is assigned.
   */
  name?: string | null;
};

/**
 * Request to update the answers on an existing submission.
 */
export type UpdateSubmissionResponsesRequest = {
  /**
   * Gets or sets the updated responses, keyed by question slug.
   */
  responses: {
    [key: string]: string | null;
  };
};

export type UpdateMySubmissionResponsesRequest = {
  /**
   * Gets or sets the updated responses, keyed by question slug.
   */
  responses: {
    [key: string]: string | null;
  };
};

/**
 * Represents aggregated income and expense analytics computed from a submission's responses.
 */
export type Analytics = {
  /**
   * Gets or sets the spouse's computed income, if applicable.
   */
  spouseIncome?: Income | null;
  /**
   * Gets or sets the profile's computed income.
   */
  income?: Income | null;
  /**
   * Gets the combined income of the profile and their spouse.
   */
  totalIncome?: Income | null;
  /**
   * Gets the total of all annual expenses across all expense categories.
   */
  annualExpensesTotal: number;
  /**
   * Gets the total of all monthly expenses across all expense categories.
   */
  monthlyExpensesTotal: number;
  /**
   * Gets the combined monthly expenses across all categories, keyed by expense group.
   */
  monthlyExpenses: {
    [key: string]: number;
  };
  /**
   * Gets the combined annual expenses across all categories, keyed by expense group.
   */
  annualExpenses: {
    [key: string]: number;
  };
  /**
   * Gets or sets the episodic (infrequent, one-off) expenses.
   */
  episodicExpenses: Expense;
  /**
   * Gets or sets the fixed (recurring, constant) expenses.
   */
  fixedExpenses: Expense;
  /**
   * Gets or sets the variable (fluctuating) expenses.
   */
  variableExpenses: Expense;
};

/**
 * Represents a person's income, before and after estimated taxes.
 */
export type Income = {
  /**
   * Gets or sets the total gross income for the year.
   */
  annualGross: number;
  /**
   * Gets the gross income for a single month.
   */
  monthlyGross: number;
  /**
   * Gets or sets the total take-home (after-tax) income for the year.
   */
  annualTakeHome: number;
  /**
   * Gets the take-home (after-tax) income for a single month.
   */
  monthlyTakeHome: number;
  /**
   * Gets or sets the estimated taxes owed for the year.
   */
  estimatedTaxes: number;
};

/**
 * Represents a set of expenses tracked by both their monthly and annual amounts.
 */
export type Expense = {
  /**
   * Gets the monthly expense amounts, keyed by expense group.
   */
  monthly: {
    [key: string]: number;
  };
  /**
   * Gets the annual expense amounts, keyed by expense group.
   */
  annual: {
    [key: string]: number;
  };
  /**
   * Gets the sum of all monthly expense amounts.
   */
  monthlyTotal: number;
  /**
   * Gets the sum of all annual expense amounts.
   */
  annualTotal: number;
};

/**
 * Request to retrieve analytics for a specific submission.
 */
export type GetSubmissionAnalyticsRequest = {
  [key: string]: never;
};

export type GetMySubmissionAnalyticsRequest = unknown;

/**
 * Represents a completed submission of responses for a survey version.
 */
export type SubmissionDto = {
  /**
   * Gets or sets the unique identifier of the submission.
   */
  id: string;
  /**
   * Gets or sets the slug of the survey the submission belongs to.
   */
  surveySlug: string;
  /**
   * Gets or sets the version number of the survey the submission was made against.
   */
  surveyVersion: number;
  /**
   * Gets or sets the identifier of the submission template the submission was created from, if any.
   */
  submissionTemplateId?: string | null;
  /**
   * Gets or sets the date and time the submission was created.
   */
  createdAt: string;
  /**
   * Gets or sets the date and time the submission was last updated.
   */
  updatedAt: string;
  /**
   * Gets or sets the submitted responses, keyed by question slug.
   */
  responses: {
    [key: string]: string;
  };
};

/**
 * Request to retrieve a specific submission.
 */
export type GetSubmissionRequest = {
  [key: string]: never;
};

export type GetMySubmissionRequest = unknown;

/**
 * Summary of a single submission returned from GetAllSubmissionsHandler.
 */
export type GetAllSubmissionsResponse = {
  /**
   * Gets or sets the submission ID.
   */
  id: string;
  /**
   * Gets or sets the slug of the survey the submission belongs to.
   */
  surveySlug: string;
  /**
   * Gets or sets the version number of the survey the submission was made against.
   */
  surveyVersion: number;
  /**
   * Gets or sets the date and time the submission was created.
   */
  createdAt: string;
  /**
   * Gets or sets the date and time the submission was last updated.
   */
  updatedAt: string;
};

/**
 * Request to retrieve all submissions for a given profile.
 */
export type GetAllSubmissionsRequest = {
  [key: string]: never;
};

export type GetMySubmissionsRequest = unknown;

/**
 * Request to create a new submission for the current user against a survey.
 */
export type CreateSubmissionRequest = {
  /**
   * Gets or sets the slug of the survey to create a submission for.
   */
  surveySlug: string;
  /**
   * Gets or sets the ID of the submission template the submission is being created from, if any.
   */
  submissionTemplateId?: string | null;
  /**
   * Gets or sets a value indicating whether the new profile belongs to a test user.
   */
  test?: boolean | null;
};

/**
 * Represents a user profile.
 */
export type ProfileDto = {
  /**
   * Gets or sets the unique identifier of the profile.
   */
  id: string;
  /**
   * Gets or sets the roles assigned to the profile.
   */
  roles: Array<Role>;
  /**
   * Gets or sets the display name of the profile.
   */
  name?: string | null;
  /**
   * Gets or sets the email address of the profile.
   */
  email?: string | null;
  /**
   * Gets or sets a value indicating whether the profile belongs to a test user.
   */
  test: boolean;
  /**
   * Gets or sets the feature toggle states enabled for the profile.
   */
  featureToggles: {
    [key: string]: boolean;
  };
};

/**
 * Authorization roles a user account can hold.
 */
export const Role = {
  /**
   * SurveyUser
   */
  SurveyUser: 'SurveyUser' /**
   * Admin
   */,
  Admin: 'Admin',
} as const;

/**
 * Authorization roles a user account can hold.
 */
export type Role = (typeof Role)[keyof typeof Role];

/**
 * Identifies a feature that can be toggled on or off for a subset of users.
 */
export const FeatureToggleType = {
  /**
   * EnableQuestionEditor
   */
  EnableQuestionEditor: 'EnableQuestionEditor',
} as const;

/**
 * Identifies a feature that can be toggled on or off for a subset of users.
 */
export type FeatureToggleType = (typeof FeatureToggleType)[keyof typeof FeatureToggleType];

/**
 * Request to retrieve a profile by ID.
 */
export type GetProfileRequest = {
  [key: string]: never;
};

export type GetMyProfileRequest = unknown;

/**
 * A page of items returned from a paginated query, along with paging metadata.
 */
export type PaginatedListDtoOfProfileDto = {
  /**
   * Gets the total number of pages, computed from TotalCount and PageSize.
   */
  totalPages: number;
  /**
   * Gets a value indicating whether there is a page after this one.
   */
  hasNextPage: boolean;
  /**
   * Gets a value indicating whether there is a page before this one.
   */
  hasPreviousPage: boolean;
  /**
   * Gets the items included in this page.
   */
  items: Array<ProfileDto>;
  /**
   * Gets the total number of items across all pages.
   */
  totalCount: number;
  /**
   * Gets the zero-based index of this page.
   */
  page: number;
  /**
   * Gets the maximum number of items per page.
   */
  pageSize: number;
};

/**
 * Request to search profiles with optional filtering and pagination.
 */
export type SearchProfilesRequest = {
  [key: string]: never;
};

/**
 * Request to soft-delete a profile and all of its submissions.
 */
export type DeleteProfileRequest = {
  [key: string]: never;
};

/**
 * Request to soft-delete every test profile and all of their submissions.
 */
export type DeleteTestProfilesRequest = {
  /**
   * Gets or sets a value indicating whether the request confirms that test profiles are the ones to delete. It must be true so that a request without it never deletes anything.
   */
  test: boolean;
};

/**
 * Response containing the issued sign-in token and the ID of the signed-in profile.
 */
export type LocalSignInResponse = {
  /**
   * The issued sign-in token.
   */
  token: string;
  /**
   * The ID of the signed-in profile.
   */
  profileId: string;
};

/**
 * Request to sign in as the first profile matching a search query. Intended for local development only.
 */
export type LocalSignInRequest = {
  [key: string]: never;
};

/**
 * Request to sign out the currently authenticated user.
 */
export type LogoutRequest = {
  [key: string]: never;
};

/**
 * Request to sign in a user via a third-party OAuth access token.
 */
export type OAuthSignInRequest = {
  /**
   * Gets the type of the OAuth token being presented.
   */
  tokenType: TokenTypes;
  /**
   * Gets the OAuth access token to validate and sign in with.
   */
  accessToken: string;
};

/**
 * The recognized types of authentication tokens.
 */
export const TokenTypes = {
  /**
   * Internal
   */
  Internal: 'Internal' /**
   * Microsoft
   */,
  Microsoft: 'Microsoft',
} as const;

/**
 * The recognized types of authentication tokens.
 */
export type TokenTypes = (typeof TokenTypes)[keyof typeof TokenTypes];

export type GetAllSurveyVersionsData = {
  body?: never;
  path: {
    /**
     * Gets or sets the slug of the survey whose versions should be retrieved.
     */
    surveySlug: string;
  };
  query: {
    /**
     * Gets or sets the page number to retrieve.
     */
    page: number;
  };
  url: '/survey/{surveySlug}/versions';
};

export type GetAllSurveyVersionsErrors = {
  /**
   * Bad Request
   */
  400: ErrorResponse;
  /**
   * Unauthorized
   */
  401: unknown;
  /**
   * Forbidden
   */
  403: unknown;
};

export type GetAllSurveyVersionsError = GetAllSurveyVersionsErrors[keyof GetAllSurveyVersionsErrors];

export type GetAllSurveyVersionsResponses = {
  /**
   * Success
   */
  200: PaginatedListDtoOfMinifiedSurveyVersionDto;
};

export type GetAllSurveyVersionsResponse = GetAllSurveyVersionsResponses[keyof GetAllSurveyVersionsResponses];

export type GetCurrentSurveyVersionData = {
  body?: never;
  path: {
    /**
     * Gets or sets the slug of the survey whose current version should be retrieved.
     */
    surveySlug: string;
  };
  query?: {
    /**
     * Gets or sets the ID of the submission template whose responses replace the default values of the returned questions, if any.
     */
    submissionTemplateId?: string | null;
  };
  url: '/survey/{surveySlug}/versions/current';
};

export type GetCurrentSurveyVersionResponses = {
  /**
   * Success
   */
  200: SurveyVersionDto;
};

export type GetCurrentSurveyVersionResponse = GetCurrentSurveyVersionResponses[keyof GetCurrentSurveyVersionResponses];

export type GetSpecificSurveyVersionData = {
  body?: never;
  path: {
    /**
     * Gets or sets the slug of the survey whose version should be retrieved.
     */
    surveySlug: string;
    /**
     * Gets or sets the version number to retrieve.
     */
    version: number;
  };
  query?: never;
  url: '/survey/{surveySlug}/versions/{version}';
};

export type GetSpecificSurveyVersionErrors = {
  /**
   * Unauthorized
   */
  401: unknown;
  /**
   * Forbidden
   */
  403: unknown;
};

export type GetSpecificSurveyVersionResponses = {
  /**
   * Success
   */
  200: SurveyVersionDto;
};

export type GetSpecificSurveyVersionResponse =
  GetSpecificSurveyVersionResponses[keyof GetSpecificSurveyVersionResponses];

export type GetAllSurveysData = {
  body?: never;
  path?: never;
  query: {
    /**
     * Gets or sets the search text used to filter surveys.
     */
    search?: string | null;
    /**
     * Gets or sets the page number to retrieve.
     */
    page: number;
  };
  url: '/survey';
};

export type GetAllSurveysErrors = {
  /**
   * Bad Request
   */
  400: ErrorResponse;
  /**
   * Unauthorized
   */
  401: unknown;
  /**
   * Forbidden
   */
  403: unknown;
};

export type GetAllSurveysError = GetAllSurveysErrors[keyof GetAllSurveysErrors];

export type GetAllSurveysResponses = {
  /**
   * Success
   */
  200: PaginatedListDtoOfSurveyDto;
};

export type GetAllSurveysResponse = GetAllSurveysResponses[keyof GetAllSurveysResponses];

export type GetSurveyData = {
  body?: never;
  path: {
    /**
     * Gets or sets the slug of the survey to retrieve.
     */
    surveySlug: string;
  };
  query?: never;
  url: '/survey/{surveySlug}';
};

export type GetSurveyErrors = {
  /**
   * Bad Request
   */
  400: ErrorResponse;
  /**
   * Unauthorized
   */
  401: unknown;
  /**
   * Forbidden
   */
  403: unknown;
};

export type GetSurveyError = GetSurveyErrors[keyof GetSurveyErrors];

export type GetSurveyResponses = {
  /**
   * Success
   */
  200: SurveyDto;
};

export type GetSurveyResponse = GetSurveyResponses[keyof GetSurveyResponses];

export type DeleteSubmissionTemplateData = {
  body?: never;
  path: {
    /**
     * Gets or sets the slug of the survey the template belongs to.
     */
    surveySlug: string;
    /**
     * Gets or sets the ID of the template to delete.
     */
    templateId: string;
  };
  query?: never;
  url: '/survey/{surveySlug}/templates/{templateId}';
};

export type DeleteSubmissionTemplateErrors = {
  /**
   * Unauthorized
   */
  401: unknown;
  /**
   * Forbidden
   */
  403: unknown;
};

export type DeleteSubmissionTemplateResponses = {
  /**
   * No Content
   */
  204: void;
};

export type DeleteSubmissionTemplateResponse =
  DeleteSubmissionTemplateResponses[keyof DeleteSubmissionTemplateResponses];

export type GetSubmissionTemplateData = {
  body?: never;
  path: {
    /**
     * Gets or sets the slug of the survey the template belongs to.
     */
    surveySlug: string;
    /**
     * Gets or sets the ID of the template to retrieve.
     */
    templateId: string;
  };
  query?: never;
  url: '/survey/{surveySlug}/templates/{templateId}';
};

export type GetSubmissionTemplateErrors = {
  /**
   * Unauthorized
   */
  401: unknown;
  /**
   * Forbidden
   */
  403: unknown;
};

export type GetSubmissionTemplateResponses = {
  /**
   * Success
   */
  200: SubmissionTemplateDto;
};

export type GetSubmissionTemplateResponse = GetSubmissionTemplateResponses[keyof GetSubmissionTemplateResponses];

export type UpdateSubmissionTemplateData = {
  body: UpdateSubmissionTemplateRequest;
  path: {
    /**
     * Gets or sets the slug of the survey the template belongs to.
     */
    surveySlug: string;
    /**
     * Gets or sets the ID of the template to update.
     */
    templateId: string;
  };
  query?: never;
  url: '/survey/{surveySlug}/templates/{templateId}';
};

export type UpdateSubmissionTemplateErrors = {
  /**
   * Bad Request
   */
  400: ErrorResponse;
  /**
   * Unauthorized
   */
  401: unknown;
  /**
   * Forbidden
   */
  403: unknown;
};

export type UpdateSubmissionTemplateError = UpdateSubmissionTemplateErrors[keyof UpdateSubmissionTemplateErrors];

export type UpdateSubmissionTemplateResponses = {
  /**
   * No Content
   */
  204: void;
};

export type UpdateSubmissionTemplateResponse =
  UpdateSubmissionTemplateResponses[keyof UpdateSubmissionTemplateResponses];

export type GetSubmissionTemplatesData = {
  body?: never;
  path: {
    /**
     * Gets or sets the slug of the survey whose templates should be retrieved.
     */
    surveySlug: string;
  };
  query: {
    /**
     * Gets or sets the page number to retrieve.
     */
    page: number;
    /**
     * Gets or sets an optional case-insensitive search term to filter templates by name.
     */
    search?: string | null;
  };
  url: '/survey/{surveySlug}/templates';
};

export type GetSubmissionTemplatesErrors = {
  /**
   * Bad Request
   */
  400: ErrorResponse;
  /**
   * Unauthorized
   */
  401: unknown;
  /**
   * Forbidden
   */
  403: unknown;
};

export type GetSubmissionTemplatesError = GetSubmissionTemplatesErrors[keyof GetSubmissionTemplatesErrors];

export type GetSubmissionTemplatesResponses = {
  /**
   * Success
   */
  200: PaginatedListDtoOfSubmissionTemplateDto;
};

export type GetSubmissionTemplatesResponse = GetSubmissionTemplatesResponses[keyof GetSubmissionTemplatesResponses];

export type CreateSubmissionTemplateData = {
  body: CreateSubmissionTemplateRequest;
  path: {
    /**
     * Gets or sets the slug of the survey the template should belong to.
     */
    surveySlug: string;
  };
  query?: never;
  url: '/survey/{surveySlug}/templates';
};

export type CreateSubmissionTemplateErrors = {
  /**
   * Bad Request
   */
  400: ErrorResponse;
  /**
   * Unauthorized
   */
  401: unknown;
  /**
   * Forbidden
   */
  403: unknown;
};

export type CreateSubmissionTemplateError = CreateSubmissionTemplateErrors[keyof CreateSubmissionTemplateErrors];

export type CreateSubmissionTemplateResponses = {
  /**
   * Success
   */
  200: SubmissionTemplateDto;
};

export type CreateSubmissionTemplateResponse =
  CreateSubmissionTemplateResponses[keyof CreateSubmissionTemplateResponses];

export type GetSubmissionData = {
  body?: never;
  path: {
    /**
     * Gets or sets the ID of the profile that owns the submission.
     */
    profileId: string;
    /**
     * Gets or sets the ID of the submission to retrieve.
     */
    submissionId: string;
  };
  query?: never;
  url: '/profile/{profileId}/submissions/{submissionId}';
};

export type GetSubmissionErrors = {
  /**
   * Unauthorized
   */
  401: unknown;
  /**
   * Forbidden
   */
  403: unknown;
};

export type GetSubmissionResponses = {
  /**
   * Success
   */
  200: SubmissionDto;
};

export type GetSubmissionResponse = GetSubmissionResponses[keyof GetSubmissionResponses];

export type UpdateSubmissionResponsesData = {
  body: UpdateSubmissionResponsesRequest;
  path: {
    /**
     * Gets or sets the ID of the profile that owns the submission.
     */
    profileId: string;
    /**
     * Gets or sets the ID of the submission to update.
     */
    submissionId: string;
  };
  query?: never;
  url: '/profile/{profileId}/submissions/{submissionId}';
};

export type UpdateSubmissionResponsesErrors = {
  /**
   * Unauthorized
   */
  401: unknown;
  /**
   * Forbidden
   */
  403: unknown;
};

export type UpdateSubmissionResponsesResponses = {
  /**
   * No Content
   */
  204: void;
};

export type UpdateSubmissionResponsesResponse =
  UpdateSubmissionResponsesResponses[keyof UpdateSubmissionResponsesResponses];

export type GetMySubmissionData = {
  body?: never;
  path: {
    submissionId: string;
  };
  query?: never;
  url: '/profile/me/submissions/{submissionId}';
};

export type GetMySubmissionErrors = {
  /**
   * Unauthorized
   */
  401: unknown;
  /**
   * Forbidden
   */
  403: unknown;
};

export type GetMySubmissionResponses = {
  /**
   * Success
   */
  200: SubmissionDto;
};

export type GetMySubmissionResponse = GetMySubmissionResponses[keyof GetMySubmissionResponses];

export type UpdateMySubmissionResponsesData = {
  body: UpdateMySubmissionResponsesRequest;
  path: {
    submissionId: string;
  };
  query?: never;
  url: '/profile/me/submissions/{submissionId}';
};

export type UpdateMySubmissionResponsesErrors = {
  /**
   * Unauthorized
   */
  401: unknown;
  /**
   * Forbidden
   */
  403: unknown;
};

export type UpdateMySubmissionResponsesResponses = {
  /**
   * No Content
   */
  204: void;
};

export type UpdateMySubmissionResponsesResponse =
  UpdateMySubmissionResponsesResponses[keyof UpdateMySubmissionResponsesResponses];

export type GetAnalyticsForSubmissionData = {
  body?: never;
  path: {
    /**
     * Gets or sets the ID of the profile that owns the submission.
     */
    profileId: string;
    /**
     * Gets or sets the ID of the submission to retrieve analytics for.
     */
    submissionId: string;
  };
  query?: never;
  url: '/profile/{profileId}/submissions/{submissionId}/analytics';
};

export type GetAnalyticsForSubmissionErrors = {
  /**
   * Unauthorized
   */
  401: unknown;
  /**
   * Forbidden
   */
  403: unknown;
};

export type GetAnalyticsForSubmissionResponses = {
  /**
   * Success
   */
  200: Analytics;
};

export type GetAnalyticsForSubmissionResponse =
  GetAnalyticsForSubmissionResponses[keyof GetAnalyticsForSubmissionResponses];

export type GetAnalyticsForMySubmissionData = {
  body?: never;
  path: {
    submissionId: string;
  };
  query?: never;
  url: '/profile/me/submissions/{submissionId}/analytics';
};

export type GetAnalyticsForMySubmissionErrors = {
  /**
   * Unauthorized
   */
  401: unknown;
  /**
   * Forbidden
   */
  403: unknown;
};

export type GetAnalyticsForMySubmissionResponses = {
  /**
   * Success
   */
  200: Analytics;
};

export type GetAnalyticsForMySubmissionResponse =
  GetAnalyticsForMySubmissionResponses[keyof GetAnalyticsForMySubmissionResponses];

export type GetSubmissionsData = {
  body?: never;
  path: {
    /**
     * Gets or sets the ID of the profile whose submissions should be retrieved.
     */
    profileId: string;
  };
  query?: never;
  url: '/profile/{profileId}/submissions';
};

export type GetSubmissionsErrors = {
  /**
   * Unauthorized
   */
  401: unknown;
  /**
   * Forbidden
   */
  403: unknown;
};

export type GetSubmissionsResponses = {
  /**
   * Success
   */
  200: Array<GetAllSubmissionsResponse>;
};

export type GetSubmissionsResponse = GetSubmissionsResponses[keyof GetSubmissionsResponses];

export type GetMySubmissionsData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/profile/me/submissions';
};

export type GetMySubmissionsErrors = {
  /**
   * Unauthorized
   */
  401: unknown;
  /**
   * Forbidden
   */
  403: unknown;
};

export type GetMySubmissionsResponses = {
  /**
   * Success
   */
  200: Array<GetAllSubmissionsResponse>;
};

export type GetMySubmissionsResponse = GetMySubmissionsResponses[keyof GetMySubmissionsResponses];

export type CreateSubmissionData = {
  body: CreateSubmissionRequest;
  path?: never;
  query?: never;
  url: '/profile/me/submissions';
};

export type CreateSubmissionResponses = {
  /**
   * Success
   */
  200: SubmissionDto;
};

export type CreateSubmissionResponse = CreateSubmissionResponses[keyof CreateSubmissionResponses];

export type DeleteProfileData = {
  body?: never;
  path: {
    /**
     * Gets or sets the ID of the profile to delete.
     */
    profileId: string;
  };
  query?: never;
  url: '/profile/{profileId}';
};

export type DeleteProfileErrors = {
  /**
   * Unauthorized
   */
  401: unknown;
  /**
   * Forbidden
   */
  403: unknown;
};

export type DeleteProfileResponses = {
  /**
   * No Content
   */
  204: void;
};

export type DeleteProfileResponse = DeleteProfileResponses[keyof DeleteProfileResponses];

export type GetProfileData = {
  body?: never;
  path: {
    /**
     * Gets or sets the ID of the profile to retrieve.
     */
    profileId: string;
  };
  query?: never;
  url: '/profile/{profileId}';
};

export type GetProfileErrors = {
  /**
   * Unauthorized
   */
  401: unknown;
  /**
   * Forbidden
   */
  403: unknown;
};

export type GetProfileResponses = {
  /**
   * Success
   */
  200: ProfileDto;
};

export type GetProfileResponse = GetProfileResponses[keyof GetProfileResponses];

export type GetMyProfileData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/profile/me';
};

export type GetMyProfileErrors = {
  /**
   * Unauthorized
   */
  401: unknown;
  /**
   * Forbidden
   */
  403: unknown;
};

export type GetMyProfileResponses = {
  /**
   * Success
   */
  200: ProfileDto;
};

export type GetMyProfileResponse = GetMyProfileResponses[keyof GetMyProfileResponses];

export type DeleteTestProfilesData = {
  body: DeleteTestProfilesRequest;
  path?: never;
  query?: never;
  url: '/profile';
};

export type DeleteTestProfilesErrors = {
  /**
   * Bad Request
   */
  400: ErrorResponse;
  /**
   * Unauthorized
   */
  401: unknown;
  /**
   * Forbidden
   */
  403: unknown;
};

export type DeleteTestProfilesError = DeleteTestProfilesErrors[keyof DeleteTestProfilesErrors];

export type DeleteTestProfilesResponses = {
  /**
   * No Content
   */
  204: void;
};

export type DeleteTestProfilesResponse = DeleteTestProfilesResponses[keyof DeleteTestProfilesResponses];

export type SearchProfilesData = {
  body?: never;
  path?: never;
  query: {
    /**
     * Gets or sets the search text used to filter profiles.
     */
    search?: string | null;
    /**
     * Gets or sets the page number to retrieve.
     */
    page: number;
  };
  url: '/profile';
};

export type SearchProfilesErrors = {
  /**
   * Bad Request
   */
  400: ErrorResponse;
  /**
   * Unauthorized
   */
  401: unknown;
  /**
   * Forbidden
   */
  403: unknown;
};

export type SearchProfilesError = SearchProfilesErrors[keyof SearchProfilesErrors];

export type SearchProfilesResponses = {
  /**
   * Success
   */
  200: PaginatedListDtoOfProfileDto;
};

export type SearchProfilesResponse = SearchProfilesResponses[keyof SearchProfilesResponses];

export type LocalSignInEndpointData = {
  body?: never;
  path?: never;
  query: {
    /**
     * Gets or sets the search text used to find the profile to sign in as.
     */
    search: string;
  };
  url: '/local/sign-in';
};

export type LocalSignInEndpointResponses = {
  /**
   * Success
   */
  200: LocalSignInResponse;
};

export type LocalSignInEndpointResponse = LocalSignInEndpointResponses[keyof LocalSignInEndpointResponses];

export type LogoutData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/auth/logout';
};

export type LogoutResponses = {
  /**
   * No Content
   */
  204: void;
};

export type LogoutResponse = LogoutResponses[keyof LogoutResponses];

export type OAuthSignInData = {
  body: OAuthSignInRequest;
  path?: never;
  query?: {
    /**
     * Gets or sets the ID of the profile associated with the authenticated user, if already known.
     */
    profileId?: string | null;
  };
  url: '/auth/oauth-signin';
};

export type OAuthSignInErrors = {
  /**
   * Bad Request
   */
  400: ErrorResponse;
};

export type OAuthSignInError = OAuthSignInErrors[keyof OAuthSignInErrors];

export type OAuthSignInResponses = {
  /**
   * No Content
   */
  204: void;
};

export type OAuthSignInResponse = OAuthSignInResponses[keyof OAuthSignInResponses];
